<template>
  <div>
    <div class="container">
      <div class="row">
        <table>
          <!--<tr>
					<td>
						<img src="./../resource/mstar_dbrs_logo.png" width="350" height="100" >
					</td>
				</tr>-->
          <tr>
            <td>
              <!-- <h2 style="margin-top: 10px; margin-left: 15px;margin-bottom: 10px;"></h2> -->
            </td>
          </tr>
        </table>
      </div>
    </div>
    <!-- <form id="form_id" @submit.prevent="processForm" > -->
    <div class="container">
      <table class="table-horizontal" width="50%" height="20">
        <tbody>
          <tr>
            <td><strong>Date</strong></td>
            <td>
              <input
                class="us"
                type="text"
                v-model="feeddate"
                readonly="true"
                required
                style="width: 273px"
              />
            </td>
          </tr>
          <tr>
            <td><strong>Group Name</strong></td>
            <td>
              <input
                class="us"
                type="text"
                v-model="group"
                readonly="true"
                required
                style="width: 273px"
              />
            </td>
          </tr>
          <tr>
            <td><strong>Deal/Company Name</strong></td>
            <td>
              <input
                class="us"
                type="text"
                size="29"
                readonly="true"
                v-model="companyname"
                required
              />
            </td>
          </tr>
          <tr>
            <td><strong>Function Supported</strong></td>
            <td>
              <input
                class="us"
                type="text"
                size="29"
                readonly="true"
                v-model="functionSupported"
                required
              />
            </td>
          </tr>
          <tr>
            <td><strong>Tasks Performed</strong></td>
            <td>
              <div id="divTaskPerformed">
                <td>
                  <input
                    class="us"
                    type="text"
                    readonly="true"
                    v-model="task_performed"
                    size="29"
                    required
                  />
                </td>
              </div>
            </td>
          </tr>
          <tr>
            <td><strong>Primary Analyst Email ID</strong></td>
            <td>
              <input
                class="us"
                type="text"
                readonly="true"
                v-model="usanalystid"
                size="29"
                required
              />
            </td>
          </tr>
          <tr>
            <td><strong>Mumbai Analyst Email ID</strong></td>
            <td>
              <input
                class="us"
                type="text"
                readonly="true"
                v-model="mumbaianalystid"
                size="29"
                required
              />
            </td>
          </tr>
          <tr
            v-if="group === 'EMEA RMBS/ABS' && task_performed === 'Par Report'"
            id="Par_Due_Date"
          >
            <td><strong>Par Due Date</strong></td>
            <td>
              <input
                class="us"
                type="text"
                readonly="true"
                v-model="Par_due_date"
                style="width: 273px"
              />
            </td>
          </tr>
          <tr id="Comment">
            <td><strong>Comment</strong></td>
            <td>
              <textarea
                class="us"
                v-model="comment"
                name="comment"
                readonly
              ></textarea>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div v-if="CRS !== 1" class="container">
    <div class="row">
      <div class="col-md-8">
        <label
          ><b
            ><u><h4>Evaluation Criteria:</h4></u></b
          ></label
        >
        <table
          id="evaluationCriteria"
          style="
            border-collapse: collapse;
            border: 1px solid black;
            width: 100%;
            border: solid;
            border-width: 1px;
          "
        >
          <tbody>
            <tr>
              <td>
                <div class="wrapper">
                  <div class="grid-header">
                    <div class="header-item"></div>
                    <div
                      class="header-itemtime"
                      style="
                        padding-left: 30px !important;
                        width: 535px !important;
                      "
                    >
                      Not Met
                    </div>
                    <div class="header-itemtime">Met</div>
                  </div>
                  <div class="grid-row">
                    <div class="flex-item">Timeliness</div>
                    <label
                      class="flex-itemtime"
                      style="
                        padding-left: 40px !important;
                        width: 535px !important;
                      "
                    >
                      <input
                        :disabled="isnotActive"
                        id="timelinessNotMet"
                        type="radio"
                        value="Not Met"
                        v-model="Timeliness"
                      />
                      <span></span>
                    </label>
                    <label class="flex-itemtime">
                      <input
                        :disabled="isnotActive"
                        type="radio"
                        value="Met"
                        v-model="Timeliness"
                      />
                      <span></span>
                    </label>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="wrapper">
                  <div
                    v-if="
                      group === 'EMEA RMBS/ABS' &&
                      functionSupported === 'Surveillance'
                    "
                    class="grid-header"
                  >
                    <div class="header-item"></div>
                    <div class="header-item"></div>
                    <div class="header-item">Needed Rework</div>
                    <div class="header-item"></div>
                    <div class="header-item">Some Adjustments Needed</div>
                    <div class="header-item"></div>
                    <div class="header-item">Highly Satisfied</div>
                  </div>
                  <div
                    v-if="
                      group === 'EMEA RMBS/ABS' &&
                      functionSupported !== 'Surveillance'
                    "
                    class="grid-header"
                  >
                    <div class="header-item"></div>
                    <div class="header-item"></div>
                    <div class="header-item">Needed Rework</div>
                    <div class="header-item"></div>
                    <div class="header-item">Satisfied</div>
                    <div class="header-item"></div>
                    <div class="header-item">Highly Satisfied</div>
                  </div>
                  <div v-if="group === 'CMBS'" class="grid-header">
                    <div class="header-item"></div>
                    <div class="header-item"></div>
                    <div
                      class="header-item"
                      v-if="task_performed === 'Presale'"
                    >
                      Major Edits
                    </div>
                    <div
                      class="header-item"
                      v-else-if="
                        (functionSupported === 'Research' &&
                          task_performed === 'Any') ||
                        (functionSupported === 'Surveillance' &&
                          (task_performed === 'Deal Surveillance' ||
                            task_performed === 'BP Updates Write-up' ||
                            task_performed === 'CRE CLO RAC requests'))
                      "
                    >
                      Needed Rework
                    </div>
                    <div class="header-item" v-else>Major Changes</div>
                    <div class="header-item"></div>

                    <div
                      class="header-item"
                      v-if="task_performed === 'Presale'"
                    >
                      Minor Edits
                    </div>
                    <div
                      class="header-item"
                      v-else-if="
                        (functionSupported === 'Research' &&
                          task_performed === 'Any') ||
                        (functionSupported === 'Surveillance' &&
                          (task_performed === 'Deal Surveillance' ||
                            task_performed === 'BP Updates Write-up' ||
                            task_performed === 'CRE CLO RAC requests'))
                      "
                    >
                      Satisfied
                    </div>
                    <div class="header-item" v-else>Minor Changes</div>
                    <div class="header-item"></div>
                    <div
                      class="header-item"
                      v-if="task_performed === 'Presale'"
                    >
                      No Edits
                    </div>
                    <div
                      class="header-item"
                      v-else-if="
                        (functionSupported === 'Research' &&
                          task_performed === 'Any') ||
                        (functionSupported === 'Surveillance' &&
                          (task_performed === 'Deal Surveillance' ||
                            task_performed === 'BP Updates Write-up' ||
                            task_performed === 'CRE CLO RAC requests'))
                      "
                    >
                      Highly Satisfied
                    </div>
                    <div class="header-item" v-else>No Changes</div>
                  </div>
                  <div v-if="group === 'ABS'" class="grid-header">
                    <div class="header-item"></div>
                    <div class="header-item"></div>
                    <div class="header-item">Not Satisfactory</div>
                    <div class="header-item"></div>
                    <div class="header-item">Satisfactory</div>
                    <div class="header-item"></div>
                    <div class="header-item">Highly Satisfactory</div>
                  </div>
                  <div
                    v-if="
                      group !== 'EMEA RMBS/ABS' &&
                      group !== 'CMBS' &&
                      group !== 'ABS'
                    "
                    class="grid-header"
                  >
                    <div class="header-item"></div>
                    <div class="header-item"></div>
                    <div class="header-item">Needed Rework</div>
                    <div class="header-item"></div>
                    <div class="header-item">Satisfied</div>
                    <div class="header-item"></div>
                    <div class="header-item">Highly Satisfied</div>
                  </div>
                  <div class="grid-header">
                    <div class="header-item"></div>
                    <div class="header-item">NA</div>
                    <div class="header-item">1</div>
                    <div class="header-item">2</div>
                    <div class="header-item">3</div>
                    <div class="header-item">4</div>
                    <div class="header-item">5</div>
                  </div>
                  <div class="grid-row">
                    <div class="flex-item">Overall Quality</div>
                    <label class="flex-item">
                      <input
                        v-if="!FeedbackQuesAns"
                        type="radio"
                        value="NA"
                        v-model="feed"
                        v-on:click="update('NA')"
                      />
                      <span></span>
                      <input
                        v-if="FeedbackQuesAns"
                        :disabled="isnotActive"
                        type="radio"
                        value="NA"
                        v-model="feed"
                      />
                      <span>{{}}</span>
                    </label>
                    <label class="flex-item">
                      <input
                        v-if="!FeedbackQuesAns"
                        type="radio"
                        value="1"
                        v-model="feed"
                        v-on:click="update(1)"
                      />
                      <span></span>
                      <input
                        v-if="FeedbackQuesAns"
                        :disabled="isnotActive"
                        type="radio"
                        value="1"
                        v-model="feed"
                      />
                      <span></span>
                    </label>
                    <label class="flex-item">
                      <input
                        v-if="!FeedbackQuesAns"
                        type="radio"
                        value="2"
                        v-model="feed"
                        v-on:click="update(2)"
                      />
                      <span></span>
                      <input
                        v-if="FeedbackQuesAns"
                        :disabled="isnotActive"
                        type="radio"
                        value="2"
                        v-model="feed"
                      />
                      <span></span>
                    </label>
                    <label class="flex-item">
                      <input
                        v-if="!FeedbackQuesAns"
                        type="radio"
                        value="3"
                        v-model="feed"
                        v-on:click="update(3)"
                      />
                      <span></span>
                      <input
                        v-if="FeedbackQuesAns"
                        :disabled="isnotActive"
                        type="radio"
                        value="3"
                        v-model="feed"
                      />
                      <span></span>
                    </label>
                    <label class="flex-item">
                      <input
                        v-if="!FeedbackQuesAns"
                        type="radio"
                        value="4"
                        v-model="feed"
                        v-on:click="update(4)"
                      />
                      <span></span>
                      <input
                        v-if="FeedbackQuesAns"
                        :disabled="isnotActive"
                        type="radio"
                        value="4"
                        v-model="feed"
                      />
                      <span></span>
                    </label>
                    <label class="flex-item">
                      <input
                        v-if="!FeedbackQuesAns"
                        type="radio"
                        value="5"
                        v-model="feed"
                        v-on:click="update(5)"
                      /><span></span>
                      <input
                        v-if="FeedbackQuesAns"
                        :disabled="isnotActive"
                        type="radio"
                        value="5"
                        v-model="feed"
                      />
                      <span></span>
                    </label>
                  </div>
                </div>
              </td>
            </tr>
            <tr
              v-for="item in questAnswMapkey"
              v-bind:key="item.id"
              v-bind:id="item"
            >
              <td v-if="item != 'Any other comments' && item != 'Timeliness'">
                <div class="wrapper">
                  <div v-if="orderDecider === 0">
                    <div
                      class="grid-header"
                      v-if="questAnswMap[item].length === 3"
                    >
                      <div class="header-item"></div>
                      <div class="header-item"></div>
                      <div class="header-item">{{ questAnswMap[item][2] }}</div>
                      <div class="header-item"></div>
                      <div class="header-item">{{ questAnswMap[item][1] }}</div>
                      <div class="header-item"></div>
                      <div class="header-item">{{ questAnswMap[item][0] }}</div>
                    </div>
                    <div
                      class="grid-header"
                      v-else-if="questAnswMap[item].length === 2"
                    >
                      <div class="header-item"></div>
                      <div class="header-item"></div>
                      <div class="header-item">{{ questAnswMap[item][1] }}</div>
                      <div class="header-item"></div>
                      <div class="header-item"></div>
                      <div class="header-item"></div>
                      <div class="header-item">{{ questAnswMap[item][0] }}</div>
                    </div>
                  </div>
                  <div v-if="orderDecider === 1">
                    <div
                      class="grid-header"
                      v-if="questAnswMap[item].length === 3"
                    >
                      <div class="header-item"></div>
                      <div class="header-item"></div>
                      <div class="header-item">{{ questAnswMap[item][0] }}</div>
                      <div class="header-item"></div>
                      <div class="header-item">{{ questAnswMap[item][1] }}</div>
                      <div class="header-item"></div>
                      <div class="header-item">{{ questAnswMap[item][2] }}</div>
                    </div>
                    <div
                      class="grid-header"
                      v-else-if="questAnswMap[item].length === 2"
                    >
                      <div class="header-item"></div>
                      <div class="header-item"></div>
                      <div class="header-item">{{ questAnswMap[item][0] }}</div>
                      <div class="header-item"></div>
                      <div class="header-item"></div>
                      <div class="header-item"></div>
                      <div class="header-item">{{ questAnswMap[item][1] }}</div>
                    </div>
                  </div>
                  <div class="grid-header">
                    <div class="header-item"></div>
                    <div class="header-item">NA</div>
                    <div class="header-item">1</div>
                    <div class="header-item">2</div>
                    <div class="header-item">3</div>
                    <div class="header-item">4</div>
                    <div class="header-item">5</div>
                  </div>
                  <div class="grid-row">
                    <div class="flex-item" v-if="group == 'RMBS'">
                      <div
                        v-if="item == 'Model Completeness'"
                        class="flex-item flex-container"
                      >
                        {{ item }}<br /><span class="flex-container"
                          >(Pool Run, Assumptions, Model Update)</span
                        >
                      </div>
                      <div
                        v-if="item == 'Data accuracy across deliverables'"
                        class="flex-item flex-container"
                      >
                        {{ item }}<br /><span class="flex-container"
                          >(Presale charts & graphs, SRC, R&W, RADAR fields,
                          Rent Data, Expense data, Cap Rate, interest rates and
                          HPI)</span
                        >
                      </div>
                      <div
                        v-if="item == 'Analytical Inputs'"
                        class="flex-item flex-container"
                      >
                        {{ item }}<br /><span class="flex-container"
                          >(Cashflows and sensitivities runs)</span
                        >
                      </div>
                    </div>

                    <div class="flex-item" v-if="group != 'RMBS'">
                      {{ item }}
                    </div>
                    <label class="flex-item">
                      <input
                        v-if="!FeedbackQuesAns"
                        type="radio"
                        value="NA"
                        v-model="dummy[item]"
                      />
                      <span></span>
                      <input
                        v-if="FeedbackQuesAns"
                        :disabled="isnotActive"
                        type="radio"
                        value="NA"
                        v-model="dummy[item]"
                      />
                      <span></span>
                    </label>
                    <label class="flex-item">
                      <input
                        v-if="!FeedbackQuesAns"
                        type="radio"
                        value="1"
                        v-model="dummy[item]"
                      />
                      <span></span>
                      <input
                        v-if="FeedbackQuesAns"
                        :disabled="isnotActive"
                        type="radio"
                        value="1"
                        v-model="dummy[item][0]"
                      />
                      <span></span>
                    </label>
                    <label class="flex-item">
                      <input
                        v-if="!FeedbackQuesAns"
                        type="radio"
                        value="2"
                        v-model="dummy[item]"
                      />
                      <span></span>
                      <input
                        v-if="FeedbackQuesAns"
                        :disabled="isnotActive"
                        type="radio"
                        value="2"
                        v-model="dummy[item][0]"
                      />
                      <span></span>
                    </label>
                    <label class="flex-item">
                      <input
                        v-if="!FeedbackQuesAns"
                        type="radio"
                        value="3"
                        v-model="dummy[item]"
                      />
                      <span></span>
                      <input
                        v-if="FeedbackQuesAns"
                        :disabled="isnotActive"
                        type="radio"
                        value="3"
                        v-model="dummy[item][0]"
                      />
                      <span></span>
                    </label>
                    <label class="flex-item">
                      <input
                        v-if="!FeedbackQuesAns"
                        type="radio"
                        value="4"
                        v-model="dummy[item]"
                      />
                      <span></span>
                      <input
                        v-if="FeedbackQuesAns"
                        :disabled="isnotActive"
                        type="radio"
                        value="4"
                        v-model="dummy[item][0]"
                      />
                      <span></span>
                    </label>
                    <label class="flex-item">
                      <input
                        v-if="!FeedbackQuesAns"
                        type="radio"
                        value="5"
                        v-model="dummy[item]"
                      /><span></span>
                      <input
                        v-if="FeedbackQuesAns"
                        :disabled="isnotActive"
                        type="radio"
                        value="5"
                        v-model="dummy[item][0]"
                      /><span></span>
                    </label>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <div class="container">
                <div class="row">
                  <td>
                    <div class="col-3 flex-item" style="width: 20% !important">
                      Comment
                    </div>
                  </td>
                  <td style="width: 500px">
                    <div class="grid-row">
                      <textarea
                        id="usComment"
                        style="width: 500px; margin-left: 100px"
                        v-model="usComment"
                        @change="getData"
                      >
                      </textarea>

                      <span v-show="Commentrequirement" style="color: red"
                        >Comment is required</span
                      >
                    </div>
                    <div id="commentdiv">
                      <div id="tooltip1" class="tooltip1">
                        <textarea
                          id="usComment"
                          style="width: 100%; height: 100%"
                          v-model="usComment"
                        >
                        </textarea>
                        <button
                          :disabled="isnotActive"
                          type="button"
                          v-on:click="closeComment"
                        >
                          Close
                        </button>
                      </div>
                    </div>
                    <span
                      v-if="!FeedbackQuesAns"
                      v-on:click="expandComment"
                      style="width: 500px; margin-left: 100px; color: blue"
                      ><u>click here to expand comment box</u></span
                    >
                  </td>
                </div>
              </div>
            </tr>
            <br />
            <tr>
              <div class="container">
                <div class="row">
                  <td><strong>Attach file</strong></td>
                  <td style="padding-left: 100px">
                    <input type="file" multiple />
                    <!-- <div class="large-12 medium-12 small-12 cell">
                                                <div v-for="(file, key) in files" class="file-listing" v-bind:key="key.id"  v-bind:id="key">{{ file.name }} <span class="remove-file" v-on:click="removeFile( key )">Remove</span></div>
                                                </div> -->
                    <div class="large-12 medium-12 small-12 cell">
                      <button :disabled="isnotActive">Add Files</button>
                    </div>
                  </td>
                </div>
              </div>
            </tr>
            <br />
            <!-- <tr>
                                <td><button style="width:400px;margin-left:150px" type="submit" :disabled="isnotActive" v-on:click="submitForm">Submit</button></td>
                            </tr>
                             -->
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <br />
  <div class="container">
    <label
      ><b
        ><u><h4>Team Lead / Manager Comments:</h4></u></b
      ></label
    >
    <br />
    <table
      id="rca"
      style="
        border-collapse: collapse;
        border: 1px solid black;
        width: 790px;
        border: solid;
        border-width: 1px;
      "
    >
      <tr>
        <td>
          <label
            ><b>
              Reason for <br />low score and <br />
              corrective action <br />to be taken</b
            ></label
          >
        </td>
        <td>
          <textarea
            :disabled="isRCASubmitted"
            class="us"
            style="width: 500px; margin-left: 50px; margin-top: 30px"
            v-model="rca_comment"
            name="comment"
          ></textarea>
        </td>
      </tr>
      <br />
      <tr>
        <td><strong>Attach file</strong></td>
        <td>
          <input
            type="file"
            id="files"
            ref="files"
            multiple
            v-on:change="handleFilesUpload"
          />
          <div style="padding-left: 50px">
            <button :disabled="isRCASubmitted" v-on:click="addFiles()">
              Add Files
            </button>
          </div>
        </td>
      </tr>
      <br />
      <tr>
        <td></td>
        <td>
          <div
            style="margin-left: 50px"
            v-for="(file, key) in files.rca_attachments"
            class="file-listing"
            v-bind:key="key.attachment_order"
            v-bind:id="key"
          >
            {{ file.name }}
            <span
              v-if="!isRCASubmitted"
              style="color: red; cursor: pointer"
              v-on:click="removeFile(key)"
              >Remove</span
            >
            <span
              v-if="isRCASubmitted"
              style="color: blue; cursor: pointer; padding-left: 5px"
              v-on:click="downloadFile(file)"
              ><u>Download</u></span
            >
          </div>
        </td>
      </tr>
      <br />
      <tr v-if="isSaving">
        <td>
          <strong>
            Upoading Files...{{ filesUploadedCount }}/{{
              files.rca_attachments.length
            }}</strong
          >
        </td>
        <td>
          <clip-loader
            style="margin-right: 450px"
            :loading="loading"
            :color="'#56A5EC'"
            :size="size"
          ></clip-loader>
        </td>
      </tr>
      <tr v-if="isSuccess">
        <td></td>
        <td>
          <strong style="margin-left: 50px"
            >files uploaded successfully...</strong
          >
        </td>
      </tr>
      <br />
      <tr>
        <td></td>
        <td>
          <button
            :disabled="isRCASubmitted"
            style="width: 400px; margin-left: 50px"
            type="submit"
            v-on:click="submitForm"
          >
            Submit
          </button>
        </td>
      </tr>
      <br />
    </table>
    <br />
    <br />
    <br />
    <br />
    <br />
  </div>
</template>
<script>
import ClipLoader from "../../node_modules/vue-spinner/src/ClipLoader.vue";

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;
const RCA_COMPLETED = 2;
const S3_DIRECTORY = "rca-file-uploads/";

export default {
  name: "RCA",
  components: {
    ClipLoader,
  },
  props: {},
  data() {
    return {
      files: [],
      isnotActive: false,
      isRCASubmitted: false,
      Commentrequirement: false,
      horizontal: "",
      message: false,
      CRS: false,
      feed: "",
      usans: {},
      usComment: "",
      jsonresponse: {},
      task_id: 0,
      feeddate: "",
      companyname: "",
      functionSupported: "",
      group: "",
      task_performed: "",
      usanalystid: "",
      mumbaianalystid: "",
      Par_due_date: "",
      comment: "",
      rca_comment: "",
      modelId: "",
      questAnswMap: [],
      questAnswMapkey: [],
      ans: [],
      dummy: {},
      rowCount: "",
      quesAns: "",
      Timeliness: "Met",
      orderDecider: 0,
      filesUploadedCount: 0,
      FeedbackQuesAns: {},
      FeedbackQuesAnsKeys: [],
      currentStatus: 0,
    };
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
  },
  methods: {
    handleFilesUpload() {
      let uploadedFiles = this.$refs.files.files;
      // console.log(uploadedFiles[0])
      for (var i = 0; i < uploadedFiles.length; i++) {
        //this.files.push( uploadedFiles[i] );
        // if(i>(this.files.attachment_count-1)){
        console.log("in handleFileUpload");
        let fileObj = {};
        fileObj.name = uploadedFiles[i].name;
        fileObj.fileinstance = uploadedFiles[i];
        this.files.rca_attachments.push(fileObj);
        // }
      }
      this.$refs.files.value = "";
    },
    addFiles() {
      this.$refs.files.click();
    },
    removeFile(key) {
      this.files.rca_attachments.splice(key, 1);
    },
    async downloadFile(file) {
      const url =
        process.env.VUE_APP_RCA_LAMBDA +
        "rca_page/attachments/generate_download_link?";
      const request = new Request(
        url + new URLSearchParams({ s3_file_name: file.s3_name }),
        { method: "GET", credentials: "include" },
      );
      const link = await fetch(request)
        .then((res) => res.json())
        .then((res) => {
          if (res.status == 200) {
            return res.data;
          }
        })
        .catch((err) => {
          console.log("ERR Getting Dowload link " + err);
        });
      //console.log('download link = ' + link)
      window.open(link, "_blank");
    },
    validateForm() {
      if (this.rca_comment.length < 1) {
        alert("RCA comment box cannot be empty");
        return false;
      }
      return true;
    },
    getPresignedURL(fileName, fileType) {
      const presignedURL = "presigned_url" + "?";
      const url =
        process.env.VUE_APP_RCA_LAMBDA +
        presignedURL +
        new URLSearchParams({
          fileName: S3_DIRECTORY + fileName,
          fileType: fileType,
        });
      const s3PresignedURL = fetch(url, {
        method: "get",
        credentials: "include",
      })
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("failed to get Presigned URL");
          }
        })
        .catch((err) => console.error(`${err.message}`));
      return s3PresignedURL;
    },
    upload(s3UploadURL = "", formData, fileName, fileType) {
      // using fetch here because AWS requires to set correct content-type
      const request = new Request(s3UploadURL, {
        method: "PUT",
        body: formData,
        headers: { "Content-Type": fileType },
      });
      const res = fetch(request)
        .then((res) => {
          if (res.ok) {
            this.filesUploadedCount++;
            return res;
          } else {
            throw new Error("failed to upload file to S3 bucket");
          }
        })
        .catch((err) => {
          console.error(`${err.message}`);
          alert(err.message);
          throw new Error(err.message);
        });
      return res;
    },
    async UploadfilesToS3(files) {
      this.currentStatus = STATUS_SAVING;
      // iterate and upload file one-by-one
      for (let i = 0; i < files.rca_attachments.length; i++) {
        if (i >= files.attachment_count) {
          let file = files.rca_attachments[i];

          // generate unique file name for s3bucket
          const newFile_name = this.task_id + "_" + i + "_" + file.name; // 10542_0_temp.pdf
          const newFile = new File([file.fileinstance], newFile_name, {
            type: file.fileinstance.type,
          });

          // get presigned URL
          const PSU = await this.getPresignedURL(newFile.name, newFile.type);
          //console.log("s3PresignedURL: " + PSU)

          // upload file to s3
          await this.upload(PSU, newFile, newFile.name, newFile.type).then(
            (res) => {
              if (res.ok) {
                console.log("file uploaded to s3 bucket successfully");
                console.log("updating the file info in db");

                // mark file as uploaded
                delete files.rca_attachments[i].fileinstance;
                files.rca_attachments[i].task_id = this.task_id;
                files.rca_attachments[i].attachment_order = i;
                files.rca_attachments[i].s3_name = newFile_name;
                this.files.rca_attachments[i]["is_uploaded"] = true;

                // sync file info in DB
                const data = [];
                data.push(this.files.rca_attachments[i]);
                const url = "rca_page/attachments?";
                const request = new Request(
                  process.env.VUE_APP_RCA_LAMBDA + url,
                  {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    credentials: "include",
                    body: JSON.stringify(data),
                  },
                );

                fetch(request)
                  .then((res) => {
                    if (res.ok) {
                      console.log(
                        "all files uploaded and db updated successfully",
                      );
                    } else {
                      throw new Error("failed to sync file upload data in DB");
                    }
                  })
                  .catch((err) => {
                    console.error(`${err.message}`);
                    alert(err.message);
                    throw new Error(err.message);
                  });
              }
            },
          );
        }
      }
      this.currentStatus = STATUS_SUCCESS;
      return this.files;
    },
    async submitForm() {
      if (this.validateForm()) {
        if (!this.isRCASubmitted) {
          if (this.files.rca_attachments.length > 0) {
            // upload files to s3
            await this.UploadfilesToS3(this.files);
          }

          // save RCA comments and mark rca as submitted in db
          const data = {
            task_id: this.task_id,
            rca_comments: this.rca_comment,
          };
          const url = "rca_page";
          const request = new Request(process.env.VUE_APP_RCA_LAMBDA + url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify(data),
          });
          fetch(request)
            .then((res) => res.json())
            .then((res) => {
              if (res.status === 200) {
                alert("RCA submitted successfully");
                location.reload();
                return res.data;
              } else {
                throw new Error("failed to submit RCA");
              }
            })
            .catch((err) => {
              console.error(`${err.message}`);
              alert(err.message);
              throw new Error(err.message);
            });
        } else {
          alert("RCA already completed");
        }
      }
    },
  },
  async created() {
    // get search param from URL and make GET call to API for task data and eval criteria
    const searchParamString = window.location.search;
    const searchParam = new URLSearchParams(searchParamString);
    console.log(" search=> " + "taskId= " + searchParam.get("taskId"));
    // console.log(' search=> ' + 'taskId= '+searchParam.get('taskId') +'  modelId= '+ searchParam.get('modelId'))
    const taskId = searchParam.get("taskId");
    //const modelId = searchParam.get('modelId')
    if (taskId !== null && taskId > 0) {
      const rca_page = "rca_page?taskId=" + taskId;
      const request = new Request(process.env.VUE_APP_RCA_LAMBDA + rca_page, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      });
      this.jsonresponse = await fetch(request)
        .then((res) => res.json())
        .then((response) => {
          if (response.status === 200) {
            return response.data;
          }
        })
        .catch((err) => console.log("ERROR: " + err));
    } else {
      alert("not a valid link");
      window.location.href = process.env.VUE_APP_UI;
    }

    // set form data
    // remove timestamp part T00:00:00 from date 2022-09-16T00:00:00
    const indexOfT = this.jsonresponse.task_details.feed_date.indexOf("T");
    this.feeddate = this.jsonresponse.task_details.feed_date.slice(0, indexOfT);

    this.companyname = this.jsonresponse.task_details.company_name;
    this.functionSupported = this.jsonresponse.task_details.function_supported;
    this.group = this.jsonresponse.task_details.grp_name;
    this.FeedbackQuesAns = this.jsonresponse.evaluation_answers;
    if (this.FeedbackQuesAns) {
      this.FeedbackQuesAnsKeys = Object.keys(this.FeedbackQuesAns);
      this.feed = this.FeedbackQuesAns["OVERALL FEEDBACK"];
      this.usComment = this.FeedbackQuesAns["Any other comments"];
      this.Timeliness = this.FeedbackQuesAns["Timeliness"];
      for (let a of this.FeedbackQuesAnsKeys) {
        this.dummy[a] = this.FeedbackQuesAns[a];
      }
      //console.log('dummy=',JSON.stringify(this.dummy));
      this.isnotActive = true;
      document.getElementById("usComment").readOnly = true;
      document.getElementById("evaluationCriteria").classList.add("grayout");
    }
    if (this.group === "CRS") {
      this.CRS = 1;
    } else {
      this.CRS = 0;
    }
    this.task_performed = this.jsonresponse.task_details.tasks_performed;
    this.usanalystid = this.jsonresponse.task_details.us_analyst_id;
    this.mumbaianalystid = this.jsonresponse.task_details.mumbai_analyst_id;
    //this.modelId = this.jsonresponse.model_id;
    this.Par_due_date = this.jsonresponse.par_due_date;
    this.comment = this.jsonresponse.task_comments;
    this.rca_comment = this.jsonresponse.rca_details.rca_comments;
    this.isRCASubmitted =
      this.jsonresponse.rca_details.rca_status === RCA_COMPLETED ? true : false;
    //console.log('RCA submitted: ' + this.isRCASubmitted)
    this.rowCount = this.jsonresponse.task_details.rowCount;
    this.questAnswMap = this.jsonresponse.evaluation_questions;
    this.questAnswMapkey = Object.keys(this.jsonresponse.evaluation_questions);

    this.ans = Object.values(this.jsonresponse.evaluation_questions);
    this.task_id = this.jsonresponse.task_details.id;
    //this.task_id = taskId;

    console.log(this.rowCount);

    if (
      this.group == "CORPORATE" ||
      this.group == "Credit Estimate" ||
      this.group == "EMEA RMBS/ABS"
    ) {
      this.orderDecider = 1;
    }
    this.isRCASubmitted = this.jsonresponse.rca_details.is_rca_completed;

    // load the attachments for RCA
    this.files = {
      rca_attachments: this.jsonresponse.rca_details.rca_attachments,
      attachment_count: this.jsonresponse.rca_details.attachment_count,
    };
  },
};
</script>
<style scoped>
* {
  font-family:
    "Univers", HelveticaNeue, "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.tooltip1 {
  width: 90%;
  height: 200px;
  visibility: hidden;
  background-color: #fff;
  padding: 20px;
  -webkit-box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.3);
  opacity: 0;
  transition: opacity 0.5s ease;
  position: absolute;
  top: 65%;
  left: 5%;
  z-index: 1;
}

#commentdiv {
  cursor: pointer;
}

#commentdiv:hover .tooltip1 {
  visibility: visible;
  transition: opacity 0.5s ease;
  opacity: 1;
}

.wrapper {
  display: flex;
  flex-direction: column;
}
.grid-row {
  margin-bottom: 1em;
}
.grid-row,
.grid-header {
  display: flex;
  /*   flex: 1 0 auto; */
  /*   height: auto; */
}

.grid-header {
  align-items: flex-end;
}
.header-item {
  width: 100px;
  text-align: center;
  /*   border:1px solid transparent; */
}
.header-item:nth-child(1) {
  width: 180px;
}
.subtitle {
  font-size: 0.7em;
}
.flex-item:before {
  content: "";
  padding-top: 26%;
}
.flex-item {
  display: flex;
  /*   flex-basis:25%; */
  width: 100px;
  border-bottom: 1px solid #ccc;
  justify-content: center;
  align-items: center;
  /*   text-align:left; */
  font-size: 1em;
  font-weight: normal;
  color: #999;
}
.flex-item:nth-child(1) {
  border: none;
  font-size: 1.15em;
  color: #000;
  width: 180px;
  justify-content: left;
}

.flex-itemtime:before {
  content: "";
  padding-top: 26%;
}
.flex-itemtime {
  /*   flex-basis:25%; */
  border-bottom: 1px solid #ccc;
  justify-content: center;
  align-items: center;
  /*   text-align:left; */
  font-size: 1em;
  font-weight: normal;
  color: #999;
}
.flex-itemtime:nth-child(1) {
  border: none;
  font-size: 1.15em;
  color: #000;
  justify-content: left;
}
/* HTML5 Boilerplate accessible hidden styles */

[type="radio"],
[type="checkbox"] {
  border: 0;
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/* One radio button per line */
label {
  /*display: block;*/
  cursor: pointer;
}

/* the basic, unchecked style */
[type="radio"] + span:before,
[type="checkbox"] + span:before {
  content: "";
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: -0.25em;
  border: 0.125em solid #fff;
  box-shadow: 0 0 0 0.15em #555;
  transition: 0.5s ease all;
}
[type="checkbox"] + span:before {
  margin-right: 0.75em;
}

/* the checked style using the :checked pseudo class */
[type="radio"]:checked + span:before,
[type="checkbox"]:checked + span:before {
  background: black;
}

/* never forget focus styling */
[type="radio"]:focus span:after {
  content: "\0020\2190";
  font-size: 1.5em;
  line-height: 1;
  vertical-align: -0.125em;
}
.us {
  width: 273px;
}
input[type="file"] {
  display: none;
}
span.remove-file {
  color: red;
  cursor: pointer;
  float: right;
}
.flex-container {
  display: flex;
  flex-direction: column;
}
.grayout {
  opacity: 0.6; /* Real browsers */
  filter: alpha(opacity = 60); /* MSIE */
}
</style>
